import { getDragAndDropAttributes } from '@components/ArtBoard/DragAndDrop/getDragAndDropAttributes'
import {
  DRAGGABLE_TYPE,
  DROPZONE_TYPE,
} from '@components/ArtBoard/DragAndDrop/types'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import css from './SymbolDropzone.module.scss'

type Props = {
  id: string
  symbolId: string
  data: Record<string, any>
}

const SymbolDropzone: React.FC<Props> = ({ id, symbolId, data }) => {
  const isOver = useSelector<AppState, boolean>(
    ({ artboard }) =>
      id === artboard.dragAndDrop.dropZone.id &&
      !artboard.dragAndDrop.dragged.ids.includes(symbolId) &&
      artboard.dragAndDrop.dragged.type === DRAGGABLE_TYPE.SYMBOL
  )

  return (
    <div
      className={cx(css.dropzone, {
        [css.dropzoneActive]: isOver,
      })}
      {...getDragAndDropAttributes(id, DROPZONE_TYPE.SYMBOL, data)}
    >
      <div />
    </div>
  )
}

export default SymbolDropzone
